import { render, staticRenderFns } from "./RelatorioPesquisaList.vue?vue&type=template&id=6839aa03&scoped=true"
import script from "./RelatorioPesquisaList.vue?vue&type=script&lang=js"
export * from "./RelatorioPesquisaList.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPesquisaList.vue?vue&type=style&index=0&id=6839aa03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6839aa03",
  null
  
)

export default component.exports